<template>
  <v-form ref="form" class="">

    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="entry.name"
          v-bind="getObject('name')"
          label="Nome"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>      

      <BuildingLevelBoxIndex
          v-if="true"          
          :hasTableTitle="true"
          :hasTopMenu="false"
          :loading="false"
          :extraData="extraData"
          :items.sync="entry.buildingLevelBoxesAttributes"
          class="mt-6"
          :readOnly="readOnly"          
        />

    </v-row>
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue"
// import PurchaseItemIndex from "@models/purchase_items/index.vue"
import BuildingLevelBoxIndex from "@models/storage_shelves/storage_buildings/building_levels/building_level_boxes/index.vue"
import BaseUtil from "@shared_components/base_util.vue";

export default {
  data() {
    return {
      entryAttributes: {},
      // initialPurchaseItemsTotalPrice: 0,
      storageItemsTotalPrice: 0,
      pageLoading: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    enabledLots: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
    items: [],
  },
  components: {
    MaskedTextField: MaskedTextField,
    BaseUtil: BaseUtil,
    BuildingLevelBoxIndex: BuildingLevelBoxIndex,
    // PurchaseItemIndex: PurchaseItemIndex
  },
  beforeCreate: function () {
    // this.$options.components.PurchaseItemIndex = require('@models/purchase_items/index.vue').default
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);
  },
  mounted() {
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
  }
};
</script>

<style scoped></style>
